import { SUPPORTED_LOCALES, type PublicUser } from '@veriverse/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppearanceEditor } from './AppearanceEditor.js';
import { chooseLocale } from './Hud.js';

/**
 * First-login onboarding (spec §14): pick a language, then an appearance. The controls tutorial
 * follows inside the office (`ControlsTutorial`).
 */
export function FirstLogin({ user }: { user: PublicUser }) {
  const { t, i18n } = useTranslation();
  const [step, setStep] = useState<'language' | 'appearance'>('language');

  if (step === 'appearance') {
    return <AppearanceEditor user={user} firstTime />;
  }

  return (
    <main className="panel join onboarding">
      <p className="muted small">{t('onboarding.progress', { step: 1, total: 3 })}</p>
      <h1>{t('onboarding.welcome', { name: user.displayName })}</h1>
      <p className="tagline">{t('onboarding.chooseLanguage')}</p>
      <div className="stack" role="group" aria-label={t('hud.language')}>
        {SUPPORTED_LOCALES.map((locale) => (
          <button
            key={locale}
            type="button"
            className={i18n.language === locale ? undefined : 'secondary'}
            aria-pressed={i18n.language === locale}
            lang={locale}
            onClick={() => chooseLocale(locale)}
          >
            {locale === 'sv' ? 'Svenska' : 'English'}
          </button>
        ))}
      </div>
      <button type="button" onClick={() => setStep('appearance')} autoFocus>
        {t('onboarding.continue')}
      </button>
    </main>
  );
}
